export default __webpack_public_path__ + "static/influencer-market-cap-38c64054560657049fec527fde379e88.webp";